import CustomerPortal from "./CustomerPortal";

export {
	CustomerPortal
};